import { useCallback } from "react";
import {
  Dialog as BaseDialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from "./components/ui/dialog";
import { Button } from "./components/ui/button";
import { DialogAlertProps, DialogVariant } from "./types";
import "./locale/i18n";
import { useTranslation } from "react-i18next";

const titleColorVariant: Record<DialogVariant, string> = {
  default: "",
  success: "text-green-600",
  error: "text-red-600",
  warning: "text-yellow-600",
  confirm: "text-red-600",
  "confirm-green": "text-red-600"
};

export function DialogAlert({
  open,
  onOpenChange,
  title,
  description,
  variant = "default",
  confirmText,
  cancelText = "cancel",
  onConfirm,
  onCancel,
  showCancel = true,
  align = "center",
  outlet,
  persistent = false
}: DialogAlertProps) {
  const alignClass =
    align === "start" ? "justify-start"
    : align === "end" ? "justify-end"
    : "justify-center";

  const { t } = useTranslation();

  const handleCancel = useCallback(() => {
    onCancel?.();
    onOpenChange(false);
  }, [onCancel, onOpenChange]);

  const handleConfirm = useCallback(() => {
    onConfirm?.();
  }, [onConfirm]);

  return (
    <BaseDialog open={open} onOpenChange={persistent ? () => {} : onOpenChange}>
      <DialogContent className="max-w-md" showCloseButton={!persistent}>
        <DialogHeader>
          {title && <DialogTitle className={titleColorVariant[variant]}>{t(title)}</DialogTitle>}
          {description && <DialogDescription>{t(description)}</DialogDescription>}
        </DialogHeader>

        {outlet && outlet}

        <div className={`flex gap-3 mt-3 ${alignClass}`}>
          {showCancel && (
            <Button variant="cancel" onClick={handleCancel}>
              {t(cancelText)}
            </Button>
          )}
          {confirmText && (
            <Button variant={variant} onClick={handleConfirm}>
              {t(confirmText)}
            </Button>
          )}
        </div>
      </DialogContent>
    </BaseDialog>
  );
}
